var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDelete = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#5C5F62",
  d: "M8.5 3.994C8.5 2.893 9.395 2 10.5 2s2 .893 2 1.994h4c.552 0 1 .446 1 .997s-.448.997-1 .997h-12c-.552 0-1-.447-1-.997s.448-.997 1-.997zM5.5 14.508V8h2v6.508a.5.5 0 0 0 .5.498h1.5V8h2v7.006H13a.5.5 0 0 0 .5-.498V8h2v6.508A2.496 2.496 0 0 1 13 17H8c-1.38 0-2.5-1.116-2.5-2.492"
})));
export { SvgDelete as ReactComponent };
export default __webpack_public_path__ + "static/media/delete.cb5ad3d1.svg";